import React from "react";

export default function Footer(props) {

    return <div className="frm-footer">
        {/*<p className={"frm-footer-p"}>*/}
        {/*    <span className={'terms-and-cond-link'} onClick={handleShow}>Terms and conditions</span>*/}
        {/*</p>*/}
    </div>;
}